import React, { useState } from 'react'
import {
  IconMail,
  IconSend,
  IconMailOpened,
  IconCornerUpRightDouble,
  IconStar,
  IconTrash,
  IconCirclePlus,
  IconSearch,
  IconChevronLeft,
  IconChevronRight,
  IconArchiveFilled,
  IconPaperclip,
  IconMenu2,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/common/Breadcrumb';

export default function Inbox() {

  const [isChecked, setIsChecked] = useState(Array(6).fill(false));

  const handleAllCheck = () => {
    const allChecked = isChecked.every(checked => checked);
    setIsChecked(Array(6).fill(!allChecked)); // Assuming 6 rows
  };

  const handleSingleCheck = (index) => {
    const newCheckboxes = [...isChecked];
    newCheckboxes[index] = !newCheckboxes[index];
    setIsChecked(newCheckboxes);
  };

  const [isInboxMenu, setInboxMenu] = React.useState(false);
  const sidebarToggle = () => {
    setInboxMenu(!isInboxMenu);
  }

  const inboxMessage = [
    {
      name: "Herman Beck",
      link: "#",
      starred: true,
      label: "MARKETING",
      labelColor: "text-secondary",
      category: "[ThemeForest]",
      subject: "Lorem Ipsum is simply dumm dummy text of the printing and typesetting industry.",
      date: "23 Jun",
    },
    {
      name: "Mary Adams",
      link: "#",
      category: "[Support]",
      subject: "There are many variations of passages of Lorem Ipsum available, but the majority",
      date: "22 Jun",
      attachment: true,
    },
    {
      name: "June Lane",
      link: "#",
      label: "FAMILY",
      labelColor: "blue",
      category: "[Support]",
      subject: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "20 Jun",
    },
    {
      name: "Gary Camara",
      link: "#",
      category: "[CSS]",
      subject: "There are many variations of passages of Lorem Ipsum available, but the majority",
      date: "14 Jun",
    },
    {
      name: "Frank Camly",
      link: "#",
      label: "THEMEFOREST",
      labelColor: "red",
      category: "[Lucid]",
      subject: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "11 Jun",
      attachment: true,
    },
    {
      name: "Gary Camara",
      link: "#",
      label: "Work",
      labelColor: "success",
      category: "[Awwwards]",
      subject: "There are many variations of passages of Lorem Ipsum available, but the majority",
      date: "29 May",
    },
  ]

  return (
    <>
      <Breadcrumb title="Inbox" path="Inbox" />
      <div className='bg-bg-dark shadow-light rounded-lg flex relative'>
        <div className={`lg:w-[280px] w-[230px] p-15 border-r border-r-border md:block ${isInboxMenu ? 'block bg-bg-dark h-full z-[2] absolute' : 'hidden'}`}>
          <Link to="/compose" className='btn btn-primary w-full mb-20'>
            Compose
          </Link>
          <ul className='flex flex-col gap-5 mb-30'>
            <li className='transition-all duration-300 ease-in-out bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconMail className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Inbox
                  </span>
                </span>
                <span className='inline-block text-success border border-current text-[10px]/[12px] px-[8px] py-[4px] rounded-[4px]'>
                  6
                </span>
              </Link>
            </li>
            <li className='transition-all duration-300 ease-in-out hover:bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconSend className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Sent
                  </span>
                </span>
              </Link>
            </li>
            <li className='transition-all duration-300 ease-in-out hover:bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconMailOpened className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Draft
                  </span>
                </span>
                <span className='inline-block text-blue border border-current text-[10px]/[12px] px-[8px] py-[4px] rounded-[4px]'>
                  3
                </span>
              </Link>
            </li>
            <li className='transition-all duration-300 ease-in-out hover:bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconCornerUpRightDouble className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Outbox
                  </span>
                </span>
              </Link>
            </li>
            <li className='transition-all duration-300 ease-in-out hover:bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconStar className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Starred
                  </span>
                </span>
                <span className='inline-block text-yellow border border-current text-[10px]/[12px] px-[8px] py-[4px] rounded-[4px]'>
                  6
                </span>
              </Link>
            </li>
            <li className='transition-all duration-300 ease-in-out hover:bg-bg-light'>
              <Link to="#" className='p-10 flex items-center justify-between gap-5'>
                <span className='flex items-center gap-15 text-text-primary'>
                  <IconTrash className='w-[20px] h-[20px] stroke-[1.5px]' />
                  <span>
                    Trash
                  </span>
                </span>
                <span className='inline-block text-danger border border-current text-[10px]/[12px] px-[8px] py-[4px] rounded-[4px]'>
                  9
                </span>
              </Link>
            </li>
          </ul>
          <div>
            <div className='flex items-center gap-10 justify-between mb-15 font-medium'>
              Labels
              <Link to="#">
                <IconCirclePlus className='text-blue w-[20px] h-[20px] stroke-[1.5] transition-all duration-300 ease-in-out hover:text-blue-100' />
              </Link>
            </div>
            <ul className='flex flex-col gap-5'>
              <li className='p-10 transition-all duration-300 ease-in-out bg-bg-light'>
                <Link to="#" className='flex items-center justify-between gap-5'>
                  <span className='flex items-center gap-15 text-text-primary'>
                    <span className='w-[15px] h-[15px] rounded-full bg-danger' />
                    <span>
                      Web Design
                    </span>
                  </span>
                  <span className='inline-block text-info border border-current text-[10px]/[12px] px-[8px] py-[4px] rounded-[4px]'>
                    5
                  </span>
                </Link>
              </li>
              <li className='p-10 transition-all duration-300 ease-in-out hover:bg-bg-light'>
                <Link to="#" className='flex items-center justify-between gap-5'>
                  <span className='flex items-center gap-15 text-text-primary'>
                    <span className='w-[15px] h-[15px] rounded-full bg-info' />
                    <span>
                      Recharge
                    </span>
                  </span>
                </Link>
              </li>
              <li className='p-10 transition-all duration-300 ease-in-out hover:bg-bg-light'>
                <Link to="#" className='flex items-center justify-between gap-5'>
                  <span className='flex items-center gap-15 text-text-primary'>
                    <span className='w-[15px] h-[15px] rounded-full bg-black-100' />
                    <span>
                      Paypal
                    </span>
                  </span>
                </Link>
              </li>
              <li className='p-10 transition-all duration-300 ease-in-out hover:bg-bg-light'>
                <Link to="#" className='flex items-center justify-between gap-5'>
                  <span className='flex items-center gap-15 text-text-primary'>
                    <span className='w-[15px] h-[15px] rounded-full bg-blue' />
                    <span>
                      Family
                    </span>
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className='lg:w-[calc(100%-280px)] md:w-[calc(100%-230px)] w-full'>
          <div className='p-15 flex items-center justify-between gap-15 flex-wrap'>
            <div className='text-[16px]/[20px] font-medium flex items-center gap-10'>
              <button
                aria-label='inbox humburger icon'
                onClick={sidebarToggle}
                className={`md:hidden block after:contents-[] after:absolute after:z-[1] after:w-full after:h-full after:left-0 after:top-0 after:bg-bg-transparent after:backdrop-blur-[5px] ${isInboxMenu ? 'after:opacity-100 after:visible after:overflow-auto' : ' after:opacity-0 after:invisible after:overflow-hidden'}`}
              >
                <IconMenu2 className='p-5 bg-border rounded-full text-text-primary' />
              </button>
              Inbox
            </div>
            <div className='relative w-full max-w-[254px] overflow-hidden'>
              <input type='text' id='searchMail' name='searchMail' placeholder='Search Mail' className='bg-bg-dark border border-border w-full py-[6px] pl-[12px] pr-60 min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
              <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-l border-l-border right-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-r-[3px]">
                <IconSearch className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
              </button>
            </div>
          </div>
          <div className='p-15 flex items-center gap-15 justify-between flex-wrap'>
            <div className='flex items-center'>
              <label className='cus-checkbox mr-20'>
                <input
                  type="checkbox"
                  checked={isChecked.every(checked => checked)}
                  onChange={handleAllCheck}
                />
                <span className='checkmark'></span>
              </label>
              <div className='rounded border border-border leading-[1.5] mr-5 overflow-hidden'>
                <button className='px-15 py-5 lg:inline-block hidden text-text-secondary border-r border-r-border transition-all duration-300 ease-in-out hover:bg-bg-light-100'>
                  Refresh
                </button>
                <button className='px-15 py-5 lg:inline-block hidden text-text-secondary border-r border-r-border transition-all duration-300 ease-in-out hover:bg-bg-light-100'>
                  Archive
                </button>
                <button className='px-15 py-5 inline-block text-text-secondary transition-all duration-300 ease-in-out hover:bg-bg-light-100'>
                  Trash
                </button>
              </div>
              <div className='mr-5'>
                <button className='px-15 py-5 inline-block text-text-secondary rounded border border-border transition-all duration-300 ease-in-out hover:bg-bg-light-100'>
                  Tags
                </button>
              </div>
              <div>
                <button className='px-15 py-5 inline-block text-text-secondary rounded border border-border transition-all duration-300 ease-in-out hover:bg-bg-light-100'>
                  More
                </button>
              </div>
            </div>
            <div className='flex items-center gap-20'>
              <div>
                1-50/295
              </div>
              <div className='flex rounded border border-border overflow-hidden'>
                <button className='p-10 inline-block border-r border-r-border transition-all duration-300 ease-in-out hover:bg-bg-light-100 group'>
                  <IconChevronLeft className='w-[13px] h-[13px] text-text-primary' />
                </button>
                <button className='p-10 inline-block transition-all duration-300 ease-in-out hover:bg-bg-light-100 group'>
                  <IconChevronRight className='w-[13px] h-[13px] text-text-primary' />
                </button>
              </div>
            </div>
          </div>
          <div className='border-t border-t-border mt-15 mb-30'>
            {inboxMessage.map((item, key) => (
              <div key={key} className='relative text-text-primary p-15 group border-b border-b-border flex items-start justify-between gap-15'>
                <div className='flex items-start gap-10 min-w-0'>
                  <label className='cus-checkbox'>
                    <input
                      type="checkbox"
                      checked={isChecked[key]}
                      onChange={() => handleSingleCheck(key)}
                    />
                    <span className='checkmark'></span>
                  </label>
                  <button>
                    <IconStar className={`stroke-[1] w-[16px] h-[16px] mr-5 ${item.starred ? 'stroke-yellow fill-yellow' : ''}`} />
                  </button>
                  <div className='truncate'>
                    <div className='flex items-center gap-10 mb-[8px]'>
                      <Link to={item.link} className='truncate font-medium inline-block text-[16px]/[20px] transition-all duration-300 ease-in-out group-hover:text-blue'>
                        {item.name}
                      </Link>
                      {item.label && <span className={`truncate inline-block px-[8px] py-[4px] uppercase rounded text-[12px]/[1] border border-current text-${item.labelColor}`}>
                        {item.label}
                      </span>}
                    </div>
                    <div className='flex gap-10'>
                      <span>{item.category}</span>
                      <p className='truncate'>{item.subject}</p>
                    </div>
                  </div>
                </div>
                <div className='min-w-fit'>
                  <div className='flex items-center gap-5 group-hover:hidden'>
                    {item.attachment && <IconPaperclip className='w-[14px] h-[14px]' />}
                    {item.date}
                  </div>
                  <div className='group-hover:flex hidden items-stretch gap-10'>
                    <button className='bg-yellow rounded-[4px] px-10 py-[8px]'>
                      <IconArchiveFilled className='text-black w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                      <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
